import { useQuery } from 'react-query';

import { getV2ApiCompanyIdPurchaseOrdersSettings } from 'src/client/spendesk-api';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';

import { base64ToFile } from './utils';

export const useGetPurchaseOrdersSettings = () => {
  const company = useCompany();
  return useQuery([company.id, 'purchase-orders', 'settings'], async () => {
    const response = await getV2ApiCompanyIdPurchaseOrdersSettings({
      path: { companyId: company.id },
    });

    if (response.statusCode !== 200) {
      throw new Error('Failed to fetch recipient requirements');
    }
    const { companyLogo } = response.body.data;
    const logo = companyLogo
      ? base64ToFile(companyLogo.companyLogoBase64, companyLogo?.fileName)
      : null;
    return { ...response.body.data, companyLogo: logo };
  });
};
